import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Lightbox from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import silverJewelleriesHeroImage from '../assets/ourproducts/pexels-martabranco-1395306.jpg';

// Rings images
import ringImage1 from '../assets/Images/WhatsApp Image 2025-10-30 at 08.23.58.jpeg';
import ringImage2 from '../assets/Images/WhatsApp Image 2025-10-30 at 08.24.04.jpeg';
import ringImage3 from '../assets/Images/15.jpeg';
import ringImage4 from '../assets/Images/21.jpeg';
// Pendants images
import pendantImage1 from '../assets/Images/130.jpg';
import pendantImage2 from '../assets/Images/131.jpg';
import pendantImage3 from '../assets/Images/132.jpg';
import pendantImage4 from '../assets/Images/133.jpg';
// Necklaces images
import necklaceImage1 from '../assets/Images/3.jpeg';
import necklaceImage2 from '../assets/Images/131.jpg';
// Earrings images
import earringImage1 from '../assets/Images/59.jpeg';
import earringImage2 from '../assets/Images/58.jpeg';
import earringImage3 from '../assets/Images/55.jpeg';
// Bracelets images
import braceletImage1 from '../assets/Images/34.jpeg';
import braceletImage2 from '../assets/Images/46.jpeg';
import braceletImage3 from '../assets/Images/35.jpeg';
// Chains images
import chainImage1 from '../assets/Images/134.jpg';
import chainImage2 from '../assets/Images/135.jpg';
import chainImage3 from '../assets/Images/136.jpg';
import chainImage4 from '../assets/Images/137.jpg';
// Tie Pins images
import tiePinImage1 from '../assets/Images/138.jpg';
// Bangles images
import bangleImage1 from '../assets/Images/31.jpeg';

import logo1 from '../assets/Images/20.jpeg';
import logo2 from '../assets/Images/28.jpeg';
import logo3 from '../assets/Images/32.jpeg';
import logo4 from '../assets/Images/40.jpeg';
import logo5 from '../assets/Images/65.jpeg';
import logo6 from '../assets/Images/68.jpeg';
import logo7 from '../assets/Images/36.jpeg';
import logo8 from '../assets/Images/26.jpeg';
import logo9 from '../assets/Images/12.jpeg';
import logo10 from '../assets/Images/2.jpeg';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

// Animation variants
const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
};

const slideLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
};

const SilverJewelleries = () => {
    const { t } = useTranslation('silverjewelleries');

    const [index, setIndex] = useState(-1);

    const silverItems = [
        {
            label: t('categories.rings.label'),
            image: ringImage1,
            images: [
                { src: ringImage1, alt: t('categories.rings.images.1') },
                { src: ringImage2, alt: t('categories.rings.images.2') },
                { src: ringImage3, alt: t('categories.rings.images.3') },
                { src: ringImage4, alt: t('categories.rings.images.4') },
            ],
            span: 'col-span-1 row-span-1',
            description: t('categories.rings.desc'),
        },
        {
            label: t('categories.pendants.label'),
            image: pendantImage1,
            images: [
                { src: pendantImage1, alt: t('categories.pendants.images.1') },
                { src: pendantImage2, alt: t('categories.pendants.images.2') },
                { src: pendantImage3, alt: t('categories.pendants.images.3') },
                { src: pendantImage4, alt: t('categories.pendants.images.4') },
            ],
            span: 'col-span-1 row-span-1',
            description: t('categories.pendants.desc'),
        },
        {
            label: t('categories.necklaces.label'),
            image: necklaceImage1,
            images: [
                { src: necklaceImage1, alt: t('categories.necklaces.images.1') },
                { src: necklaceImage2, alt: t('categories.necklaces.images.2') },
            ],
            span: 'col-span-1 row-span-1',
            description: t('categories.necklaces.desc'),
        },
        {
            label: t('categories.earrings.label'),
            image: earringImage1,
            images: [
                { src: earringImage1, alt: t('categories.earrings.images.1') },
                { src: earringImage2, alt: t('categories.earrings.images.2') },
                { src: earringImage3, alt: t('categories.earrings.images.3') },
            ],
            span: 'col-span-1 row-span-1',
            description: t('categories.earrings.desc'),
        },
        {
            label: t('categories.bracelets.label'),
            image: braceletImage1,
            images: [
                { src: braceletImage1, alt: t('categories.bracelets.images.1') },
                { src: braceletImage2, alt: t('categories.bracelets.images.2') },
                { src: braceletImage3, alt: t('categories.bracelets.images.3') },
            ],
            span: 'col-span-1 row-span-1',
            description: t('categories.bracelets.desc'),
        },
        {
            label: t('categories.chains.label'),
            image: chainImage1,
            images: [
                { src: chainImage1, alt: t('categories.chains.images.1') },
                { src: chainImage2, alt: t('categories.chains.images.2') },
                { src: chainImage3, alt: t('categories.chains.images.3') },
                { src: chainImage4, alt: t('categories.chains.images.4') },
            ],
            span: 'col-span-1 row-span-1',
            description: t('categories.chains.desc'),
        },
    ];

    const silverItems2 = [
        {
            label: t('categories.tiePins.label'),
            image: tiePinImage1,
            images: [
                { src: tiePinImage1, alt: t('categories.tiePins.images.1') },
            ],
            description: t('categories.tiePins.desc'),
        },
        {
            label: t('categories.bangles.label'),
            image: bangleImage1,
            images: [
                { src: bangleImage1, alt: t('categories.bangles.images.1') },
            ],
            description: t('categories.bangles.desc'),
        },
    ];

    const slides = [...silverItems, ...silverItems2].flatMap((item) =>
        item.images.map((image) => ({
            src: image.src,
            alt: image.alt,
        }))
    );

    const navButtons = [
        { title: t('nav.gold'), link: '/gold-jewellery', isActive: false },
        { title: t('nav.silver'), link: '/silver-jewellery', isActive: true },
        { title: t('nav.precious'), link: '/precious-stones', isActive: false },
        { title: t('nav.semiPrecious'), link: '/semi-precious-stones', isActive: false },
    ];

    const logos = [
        logo1, logo2, logo3, logo4, logo5,
        logo6, logo7, logo8, logo9, logo10,
    ];

    const logoSliderSettings = {
        dots: false,
        infinite: true,
        speed: 5000,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        arrows: false,
        pauseOnHover: false,
        variableWidth: true,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 4 } },
            { breakpoint: 768, settings: { slidesToShow: 3 } },
        ],
    };

    const smLogoSliderSettings = {
        dots: false,
        infinite: true,
        speed: 3000,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        arrows: false,
        pauseOnHover: false,
        variableWidth: true,
    };

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Hero Section */}
            <div className="relative flex h-[80vh] w-full items-center justify-center font-lato lg:h-screen">
                <img
                    src={silverJewelleriesHeroImage}
                    alt={t('hero.alt')}
                    className="absolute inset-0 h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="container relative z-10 flex items-center justify-center pt-[100px]">
                    <div className="w-[90%] text-center md:w-[75%]">
                        <motion.h1
                            variants={textVariants}
                            initial="hidden"
                            animate="visible"
                            className="text-[45px] font-semibold leading-[60px] text-white md:text-[55px] md:leading-[80px] lg:text-[70px] font-copperplate"
                        >
                            {t('hero.title')}
                        </motion.h1>
                        <motion.div
                            variants={textVariants}
                            initial="hidden"
                            animate="visible"
                            className="my-5 text-[18px] font-medium leading-6 md:text-[20px] lg:text-[25px] lg:leading-8"
                        >
                            <span className="text-[#BF943A]">
                                {t('hero.subtitle.highlight')}
                            </span>
                            <span className="text-white">
                                {' '}{t('hero.subtitle.part2')}
                            </span>
                        </motion.div>

                        <motion.div
                            variants={slideLeft}
                            initial="hidden"
                            animate="visible"
                            className="mt-10 flex justify-center gap-4"
                        >
                            <a
                                href="/our-products"
                                className="w-[180px] rounded-full bg-white py-2 text-[14px] font-bold text-black md:text-[16px] lg:text-[18px]"
                            >
                                {t('hero.buttons.categories')}
                            </a>
                            <a
                                href="/contact-us"
                                className="w-[180px] rounded-full bg-[#BF943A] py-2 text-[14px] font-bold text-black md:text-[16px] lg:text-[18px]"
                            >
                                {t('hero.buttons.shopNow')}
                            </a>
                        </motion.div>

                        {/* decorative svgs */}
                    </div>
                </div>
            </div>

            {/* Navigation Buttons Section */}
            <section className="bg-[#1F1F1F] py-12">
                <div className="container flex justify-center gap-4 flex-wrap">
                    {navButtons.map((button, index) => (
                        <a
                            key={index}
                            href={button.link}
                            className={`px-6 py-2 rounded-full font-lato text-[16px] font-semibold transition-all duration-300 ${button.isActive
                                ? 'bg-[#BF943A] text-black'
                                : 'bg-white text-black hover:bg-[#BF943A] hover:text-black'
                                }`}
                        >
                            {button.title}
                        </a>
                    ))}
                </div>
            </section>

            {/* Silver Items Section */}
            <section className="bg-[#1F1F1F] py-12">
                <div className="container relative font-lato text-white">
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="flex items-center gap-5"
                    >
                        <div className="h-px w-[40px] bg-[#D7D7D7]"></div>
                        <h1 className="text-[25px] font-semibold uppercase md:text-[30px] lg:text-[40px]">
                            {t('silverItems.title')}
                        </h1>
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="mt-2 text-[12px] font-semibold text-[#AEAEAE] md:text-[16px] lg:text-[18px]"
                    >
                        {t('silverItems.subtitle')}
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="my-6 h-px w-full bg-[#D7D7D7] lg:my-12"
                    ></motion.div>

                    <div className="mt-16 grid auto-rows-[200px] grid-cols-2 items-stretch gap-2 md:auto-rows-[250px] md:grid-cols-3 md:gap-3 lg:auto-rows-[450px]">
                        {silverItems.map((item, i) => (
                            <button
                                key={i}
                                type="button"
                                onClick={() => setIndex(i * 4)}
                                className={`group relative cursor-pointer overflow-hidden ${item.span}`}
                                aria-label={item.label}
                            >
                                <img
                                    src={item.image}
                                    alt={item.label}
                                    className="object-cover transition-transform duration-500 group-hover:scale-110 h-full w-full"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-100 transition-opacity duration-300">
                                    <div className="absolute bottom-0 left-0 right-0 p-4">
                                        <h3 className="font-lato text-sm font-bold uppercase tracking-wider text-white md:text-xl">
                                            {item.label}
                                        </h3>
                                        <p className="mt-2 text-[12px] text-white md:text-[14px]">
                                            {item.description}
                                        </p>
                                        <div className="flex justify-end mt-2">
                                            <button
                                                onClick={() => setIndex(i * 4)}
                                                className="text-[14px] font-semibold text-[#BF943A] hover:underline md:text-[16px]"
                                            >
                                                {t('view')}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </button>
                        ))}
                    </div>

                    <div className="mt-2 flex h-auto flex-col items-center gap-2 md:mt-3 md:h-[250px] md:flex-row md:gap-3 lg:h-[450px]">
                        {silverItems2.map((item, i) => (
                            <button
                                key={i}
                                type="button"
                                onClick={() => setIndex((silverItems.length + i) * 4)}
                                className="group relative h-[255px] w-full cursor-pointer overflow-hidden md:h-full md:w-[50%]"
                                aria-label={item.label}
                            >
                                <img
                                    src={item.image}
                                    alt={item.label}
                                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-100 transition-opacity duration-300">
                                    <div className="absolute bottom-0 left-0 right-0 p-4">
                                        <h3 className="font-lato text-sm font-bold uppercase tracking-wider text-white md:text-xl">
                                            {item.label}
                                        </h3>
                                        <p className="mt-2 text-[12px] text-white md:text-[14px]">
                                            {item.description}
                                        </p>
                                        <div className="flex justify-end mt-2">
                                            <button
                                                onClick={() => setIndex((silverItems.length + i) * 4)}
                                                className="text-[14px] font-semibold text-[#BF943A] hover:underline md:text-[16px]"
                                            >
                                                {t('view')}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </button>
                        ))}
                    </div>

                    {/* Lightbox */}
                    <Lightbox
                        open={index >= 0}
                        close={() => setIndex(-1)}
                        index={index}
                        slides={slides}
                        render={{ buttonPrev: undefined, buttonNext: undefined }}
                        plugins={[Thumbnails, Zoom]}
                        carousel={{ finite: false }}
                        animation={{ fade: 250 }}
                        zoom={{ maxZoomPixelRatio: 2.5 }}
                        thumbnails={{ vignette: false, width: 100, height: 70 }}
                    />
                </div>
            </section>

            {/* Logo Sliders */}
            <section className="block sm:hidden w-full py-6 bg-[#1F1F1F] overflow-hidden">
                <div className="max-w-md mx-auto px-2">
                    <Slider {...smLogoSliderSettings}>
                        {logos.map((logo, index) => (
                            <div key={index} className="flex justify-center px-2">
                                <div className="w-[120px] h-[120px] flex items-center justify-center rounded-lg bg-white/5 p-2">
                                    <img src={logo} alt={`Logo ${index + 1}`} className="max-w-full max-h-full object-contain" loading="lazy" />
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </section>

            <section className="hidden sm:block w-full py-10 bg-[#1F1F1F] overflow-hidden">
                <div className="max-w-7xl mx-auto px-4">
                    <Slider {...logoSliderSettings}>
                        {logos.map((logo, index) => (
                            <div key={index} className="flex justify-center px-4">
                                <div className="relative w-[200px] h-[200px] flex items-center justify-center rounded-lg">
                                    <img src={logo} alt={`Logo ${index + 1}`} className="object-contain p-2" loading="lazy" />
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </section>
        </div>
    );
};

export default SilverJewelleries;